import instance from "../utils/instance";

class ChooseResourceService {
    async getResourcesList(type,name) {
		return await instance.get('/trip/resource/getResourcesList?resourceTypeId=' + type +'&name=' + name);
    }
}

export default new ChooseResourceService();